import React from 'react';
import { getTableColumns } from 'helpers';
import { FasHistory } from 'assets/icons';
import { CanUserAuditCohorts } from 'appconstants/Permission';
import atoms from 'ctsutheme/components/atoms';

const { IconButton, Typography } = atoms;

const PartColumns = [
  ['description', 'string', 'Description', 'left', true],
  ['status', 'string', 'Status', 'left', true],
  ['statusReason', 'string', 'Reason', 'left', true],
  ['statusDate', 'string', 'Status Date', 'left', true],
  ['targetAccrual', 'string', 'Accrual Target', 'left', true],
  ['currentAccrual', 'string', 'Current Accrual', 'left', true]
];

const StrataColumns = [
  {
    name: 'stratumName',
    type: 'string',
    label: 'Stratum',
    align: 'left',
    sort: false,
    renderCell: (data, rowInfo) => (
      <>
        {CanUserAuditCohorts() && (<Typography component="span" inline link icon>
                <IconButton
                    aria-label="Move row down"
                    color="inherit"
                    data-id="stratum"
                    onClick={(evt) => rowInfo[0](evt, data)}
                >
                <FasHistory />
                </IconButton>
            </Typography>)}
        <span style={{ marginRight: '1rem' }}>
          {data.stratumName}
        </span>
        </>)},
    ...getTableColumns(PartColumns)
  ];
  
  
  export default StrataColumns;
  